var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.mode == "edit"
        ? _c(
            "el-input",
            {
              attrs: {
                min: "0",
                max: "100",
                placeholder: _vm.placeholder,
                "data-bot": _vm.dataBot
              },
              on: { change: _vm.update, blur: _vm.formatAmount },
              model: {
                value: _vm.currentValue,
                callback: function($$v) {
                  _vm.currentValue = $$v
                },
                expression: "currentValue"
              }
            },
            [_c("template", { slot: "append" }, [_vm._v("%")])],
            2
          )
        : _c("p", [_vm._v(_vm._s(_vm.currentValue) + " %")])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }